/* eslint-disable no-nested-ternary */
import * as React from 'react';
import styled, { useTheme } from 'styled-components';
import PropTypes from 'prop-types';
import Link from '@base/Link/Link';
import ClassRoomLogo from '@images/classroom/classroom.svg';
import imageHelper from '@utils/imageHelper';
import { LIGHT_THEME } from '@styles/index';
import throttle from 'lodash/throttle';
import { useSelector } from 'react-redux';

const LogoStyled = styled.img`
  user-drag: none;
  user-select: none;
  height: 24px;
  @media only screen and (max-width: 47.95em) {
    ${({ $isFooter }) => ($isFooter ? '' : 'width: 25px;height: 20px;')}
  }
`;

const Logo = ({
  gridColumn,
  disabled,
  withoutText,
  isClassroom,
  isReload,
  className,
  type
}) => {
  const theme = useTheme();
  const isMobile = useSelector(({ helper }) => helper.isMobile);
  const [mobile, setMobile] = React.useState(isMobile);
  const isFooter = type === 'footer';
  const isPageReload = (e) => {
    e.preventDefault();
    window.location.href = '/';
  };
  React.useEffect(() => {
    if (window.innerWidth < 1135) {
      setMobile(true);
    } else {
      setMobile(false);
    }
    window.addEventListener(
      'resize',
      throttle((event) => {
        if (event.target.innerWidth < 1135) {
          setMobile(true);
        } else {
          setMobile(false);
        }
      }, 1000)
    );
  }, []);

  const logo = React.useMemo(() => {
    if (isClassroom) {
      return ClassRoomLogo;
    }

    if (withoutText) {
      return 'logoCups';
    }
    if (mobile && !isFooter) {
      return 'Mobile-Logo';
    }
    return theme.colors.type === LIGHT_THEME ? 'logo' : 'un_white_logo';
  }, [isClassroom, withoutText, mobile, isFooter, theme.colors.type]);

  return (
    <Link
      href="/"
      as="/"
      anchorStyle={`align-self: center; height: 24px; grid-column: ${gridColumn}; pointer-events:${
        disabled ? 'none' : 'auto'
      };${isFooter ? '' : '@media(max-width:70.95em){grid-column: 1/2;'}}`}
      onClick={isReload ? isPageReload : null}
      className={className}
    >
      <LogoStyled
        src={imageHelper.getImage(`${logo}.svg`)}
        alt="Company Logo"
        data-analytics="global"
        className={className}
        width="auto"
        height="24px"
        $isFooter={isFooter}
      />
    </Link>
  );
};

export default React.memo(Logo);

Logo.propTypes = {
  gridColumn: PropTypes.string,
  disabled: PropTypes.bool,
  withoutText: PropTypes.bool,
  isClassroom: PropTypes.bool,
  isReload: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string
};

Logo.defaultProps = {
  gridColumn: '1/5',
  disabled: false,
  withoutText: false,
  isClassroom: false,
  isReload: false,
  className: '',
  type: ''
};
